import React, { useState, useEffect } from 'react';
import { SideBarDialogTitle, SideBarDialogContent, SideBarDialogActions } from '../../Dialog/Dialog';
import {
    Button,
    Drawer,
    Grid,
    InputAdornment,
    makeStyles,
    Typography
} from '@material-ui/core';
import * as logger from '../../../../logger';
import { connect } from 'react-redux';
import { updateChatView } from "../../../../store/actions/userActionCreators";
import classNames from 'classnames';
import { numberFormat, numberFormatPaisa } from "../../../../utils/utils";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from 'leaflet';
import mapIcon from '../../../../assets/map-icon.png';
import { OpenInMap } from "../../../../components/icons";

const useStyles = makeStyles((theme) => ({

    divTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#0b1323'
    },
    sideBarDialogContentV1: {
        paddingTop: 32,
        paddingLeft: 30,
        paddingRight: 30,
        paddingBottom: 24,
        backgroundColor: '#f6f6f8'
    },
    closeButton: {
        padding: '7px 19.5px',
        borderRadius: '4px',
        boxShadow: 'none !important',
        border: 'solid 1px #d8dce6',
        backgroundImage: 'linear-gradient(to top, #f6f7f9, #fff)',
        textTransform: 'none !important',
        fontWeight: 500
    },
    transactionDetailsDrawer: {
        width: 475,
        maxWidth: 475,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px',
        }
    },
    divAlign: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    titleV1: {
        fontSize: '12px',
        fontWeight: 300,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    textAlignLeft: {
        textAlign: 'left'
    },
    textAlignRight: {
        textAlign: 'right'
    },
    consumptionCard: {
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '16px'
    },
    mt16: {
        marginTop: 16
    },
    valueText: {
        fontWeight: 600,
        fontSize: 16,
        marginTop: 2
    },
    width50: {
        width: '50%'
    },
    mt12: {
        marginTop: 12
    },
    pumpName: {
        color: "#0b1323",
        fontSize: 12,
        fontWeight: 600
    },
    pumpLocation: {
        color: " rgba(17, 35, 11, 0.59)",
        fontSize: 12,
        marginTop: 2
    },
    openMapButton: {
        padding: '4px 12px 5px',
        borderRadius: '4px',
        backgroundColor: '#2c5de5',
        color: 'white',
        fontSize: '14px',
        textTransform: 'none !important',
        boxShadow: 'none !important',
        "&:hover": {
            backgroundColor: '#2c5de5'
        }
    },
    mt24: {
        marginTop: 24
    },
    divOpenInMap: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    dialogTitleV1: {
        paddingBottom: '12px !important'
    },
    mapContainer: {
        height: "200px",
        width: "100%",
        borderRadius: 8,
        marginTop: 24
    }

}));

const mapMarker = L.divIcon({
    iconSize: [24, 31],
    iconAnchor: [10, 30],
    className: `reliance-map-marker`,
    html: `<div class="map-reliance"><img src=${mapIcon} /></div>`
});

const DieselConsumptionSideBar = ({ open, onClose, vehicle, dispatchChatView }) => {

    const [sidebarOpen, setSidebarOpen] = useState(open);
    const [consumptionDetails, setConsumptionDetails] = useState({});
    const [positionValue, setPositionValue] = useState([]);

    const classes = useStyles();

    useEffect(() => {
        dispatchChatView(false);
    }, []);

    useEffect(() => {

        if (vehicle && vehicle.dieselCardTransactionDetails) {
            const transactionDetails = vehicle.dieselCardTransactionDetails;
            setConsumptionDetails(vehicle.dieselCardTransactionDetails);
            setPositionValue([Number(transactionDetails && transactionDetails.location && transactionDetails.location.latitude ? transactionDetails.location.latitude : ""), Number(transactionDetails && transactionDetails.location && transactionDetails.location.longitude ? transactionDetails.location.longitude : "")])
        }

    }, [vehicle.dieselCardTransactionDetails]);

    const handleClose = () => {
        dispatchChatView(true);
        setSidebarOpen(false);
        onClose();
    }

    const handleOpenInMap = () => {
        window.open(`http://maps.google.co.in/maps?q=${positionValue[0]},${positionValue[1]}`);
    }

    return (
        <>
            <Drawer
                variant="temporary"
                anchor="right"
                open={sidebarOpen}
                ModalProps={{
                    keepMounted: false,
                    className: classes.modal,
                    BackdropProps: {
                        className: classes.backdrop
                    },
                    disableBackdropClick: true,
                    disableEscapeKeyDown: true,
                    //onBackdropClick: handleClose
                }}
                classes={{
                    paper: classes.transactionDetailsDrawer
                }}
            >
                <SideBarDialogTitle id={"right-sidebar-for-diesel-consumption"} siderBarType={'dieselConsumption'} onClose={handleClose} className={classes.dialogTitleV1}>
                    <div className={classes.divTitle}>
                        Diesel Consumtion Details
                    </div>
                </SideBarDialogTitle>

                <SideBarDialogContent dividers className={classes.sideBarDialogContentV1} >

                    {/* ************************ Consumption Details Card ************************ */}
                    <div className={classes.consumptionCard}>
                        <div className={classes.divAlign}>
                            <div className={classes.width50}>
                                <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Consumption Date & Time</div>
                                <div className={classNames(classes.valueText, classes.textAlignLeft)} >{consumptionDetails && consumptionDetails.transactionDate ? consumptionDetails.transactionDate : "--"} - {consumptionDetails && consumptionDetails.transactionTime ? consumptionDetails.transactionTime : "--"}</div>
                            </div>
                            <div>
                                <div className={classNames(classes.textAlignRight, classes.titleV1)}>Amount</div>
                                <div className={classNames(classes.valueText, classes.textAlignRight)}>{consumptionDetails && consumptionDetails.amount ? numberFormatPaisa(consumptionDetails.amount) : "--"}</div>
                            </div>
                        </div>

                        <div className={classes.mt16}>
                            <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Consumption Details</div>
                            <div className={classNames(classes.valueText, classes.textAlignLeft)}>{consumptionDetails && consumptionDetails.quantity ? (parseFloat(consumptionDetails.quantity)).toFixed(2) : ""} Litres filled @ {numberFormatPaisa(consumptionDetails.amount)} per Litre</div>
                        </div>
                    </div>

                    {/* *************************** Fuel Bunk Location map *************************** */}
                    <div className={classNames(classes.consumptionCard, classes.mt12)}>
                        <div className={classes.divAlign}>
                            <div>
                                <div className={classNames(classes.titleV1, classes.textAlignLeft)}>Bunk Name</div>
                                <div className={classNames(classes.valueText, classes.textAlignLeft)}>{consumptionDetails && consumptionDetails.bunkName ? consumptionDetails.bunkName : "--"}</div>
                            </div>
                            <div>
                                <div className={classNames(classes.textAlignRight, classes.titleV1)}>City</div>
                                <div className={classNames(classes.valueText, classes.textAlignRight)}>{consumptionDetails && consumptionDetails.district ? consumptionDetails.district : "--"}</div>
                            </div>
                        </div>

                        {/* **************************** Map **************************** */}
                        <div>
                            <MapContainer center={positionValue} zoom={13} className={classes.mapContainer}>
                                <TileLayer
                                    attribution="<a target=&quot;_blank&quot; href=&quot;https://transportbook.in/&quot;>TransportBook</a>"
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <Marker position={positionValue} icon={mapMarker}>
                                    <Popup>
                                        <div>
                                            <Typography className={classes.pumpName}>
                                                {consumptionDetails && consumptionDetails.bunkName ? consumptionDetails.bunkName : "--"}
                                            </Typography>
                                            <Typography className={classes.pumpLocation}>
                                                {consumptionDetails && consumptionDetails.district ? consumptionDetails.district : "--"}
                                            </Typography>
                                        </div>
                                    </Popup>
                                </Marker>
                            </MapContainer>
                        </div>

                        <div className={classNames(classes.divOpenInMap, classes.mt24)}>
                            <Button variant="contained" startIcon={<OpenInMap />} className={classes.openMapButton} onClick={() => handleOpenInMap()}>
                                Open in Map
                            </Button>
                        </div>

                    </div>

                </SideBarDialogContent>

                <SideBarDialogActions className={classes.sideBarActions} >
                    <Button variant='contained' className={classes.closeButton} onClick={handleClose}>
                        Close
                    </Button>
                </SideBarDialogActions>

            </Drawer>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchChatView: (value) => dispatch(updateChatView(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DieselConsumptionSideBar);
